export default Object.freeze({
    CHART_OF_ACCOUNT: 'chart_of_accounts',
    JOURNAL_TEMPLATE: 'journal_template',
    DOCUMENT_TOKENS_LIST: 'document_tokens_list',
    PRICING_TABLE_INSTRUCTIONS: 'pricing_table_instructions'
});